'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { TableTypeIcon } from '@/components/Shared/TableTypeIcon';
import { Dataset } from '@/lib/types/Dataset';
import { Table } from '@/lib/types/Table';
import { cn } from '@/lib/utils';
interface DatasetSidebarItemProps {
  dataset: Dataset;
  table: Table;
  tableAction: string;
}
const tableLinkActiveClass = 'bg-secondary hover:bg-secondary text-white';
const tableLinkClass = `shadow-lg no-underline flex py-3 px-5 gap-5 items-center font-mono text-xs text-secondary bg-[#acc2ff47] hover:bg-[#acc2ffe6]`;
export function DatasetSidebarItem({
  table,
  dataset,
  tableAction
}: DatasetSidebarItemProps) {
  const pathname = usePathname();
  const url = `/dataset/${dataset.name}/${table.name}/${tableAction}`;
  const isActive = pathname.startsWith(url);
  return <Link scroll={false} prefetch={false} key={`sidebar-${table.id}`} href={url} className={cn(tableLinkClass, {
    [tableLinkActiveClass]: isActive
  })}>
      {table.types.length > 0 && <div className="min-w-[33%] shrink-0 flex flex-col space-y-1 justify-center">
          {table.types.map(({
        id,
        display_name
      }) => <div className={cn('flex capitalize items-center text-left font-sans text-sm font-black gap-2', {
        ['text-white']: isActive
      })} key={`table-${table.id}-type-${id}`}>
              <TableTypeIcon size="sm" type={id} />
              <span>{display_name.en}</span>
            </div>)}
        </div>}
      <div className={cn('text-left text-balance tracking-wide font-mono', {
      ['text-white']: isActive,
      ['text-black']: !isActive
    })}>
        {table.display_name.en}
      </div>
    </Link>;
}